"use strict";
// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-workflows?path=%2Ftypes%2Fvoice%2Fsrc%2Fannotations-v2.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCommandSuggestionResult = exports.VoiceCommandSuggestion = exports.BaseVoiceCommandSuggestion = exports.VoiceCommandSuggestionInternalSignal = exports.VoiceCommandResultsInternalSignal = exports.VoiceCommandInternalResult = exports.VoiceCommandResultV2 = exports.BaseVoiceCommandResult = void 0;
var types_core_1 = require("@augloop/types-core");
var BaseVoiceCommandResult = /** @class */ (function () {
    function BaseVoiceCommandResult(obj) {
        types_core_1.SchemaObject.assign(BaseVoiceCommandResult, this, obj);
    }
    Object.defineProperty(BaseVoiceCommandResult.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    BaseVoiceCommandResult.getTypeName = function () {
        return 'AugLoop_Voice_BaseVoiceCommandResult';
    };
    BaseVoiceCommandResult.getBaseTypes = function () {
        return ['AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of BaseVoiceCommandResult type or its inheritor and implements {@link IBaseVoiceCommandResult}
     */
    BaseVoiceCommandResult.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [BaseVoiceCommandResult.getTypeName()]);
    };
    BaseVoiceCommandResult.H_ = { T_: BaseVoiceCommandResult.getTypeName(), B_: BaseVoiceCommandResult.getBaseTypes() };
    return BaseVoiceCommandResult;
}());
exports.BaseVoiceCommandResult = BaseVoiceCommandResult;
var VoiceCommandResultV2 = /** @class */ (function () {
    function VoiceCommandResultV2(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandResultV2, this, obj);
    }
    Object.defineProperty(VoiceCommandResultV2.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    VoiceCommandResultV2.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandResultV2';
    };
    VoiceCommandResultV2.getBaseTypes = function () {
        return ['AugLoop_Voice_BaseVoiceCommandResult', 'AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandResultV2 type or its inheritor and implements {@link IVoiceCommandResultV2}
     */
    VoiceCommandResultV2.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandResultV2.getTypeName()]);
    };
    VoiceCommandResultV2.H_ = { T_: VoiceCommandResultV2.getTypeName(), B_: VoiceCommandResultV2.getBaseTypes() };
    return VoiceCommandResultV2;
}());
exports.VoiceCommandResultV2 = VoiceCommandResultV2;
var VoiceCommandInternalResult = /** @class */ (function () {
    function VoiceCommandInternalResult(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandInternalResult, this, obj);
    }
    Object.defineProperty(VoiceCommandInternalResult.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    VoiceCommandInternalResult.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandInternalResult';
    };
    VoiceCommandInternalResult.getBaseTypes = function () {
        return ['AugLoop_Voice_BaseVoiceCommandResult', 'AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandInternalResult type or its inheritor and implements {@link IVoiceCommandInternalResult}
     */
    VoiceCommandInternalResult.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandInternalResult.getTypeName()]);
    };
    VoiceCommandInternalResult.H_ = { T_: VoiceCommandInternalResult.getTypeName(), B_: VoiceCommandInternalResult.getBaseTypes() };
    return VoiceCommandInternalResult;
}());
exports.VoiceCommandInternalResult = VoiceCommandInternalResult;
var VoiceCommandResultsInternalSignal = /** @class */ (function () {
    function VoiceCommandResultsInternalSignal(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandResultsInternalSignal, this, obj);
    }
    VoiceCommandResultsInternalSignal.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandResultsInternalSignal';
    };
    VoiceCommandResultsInternalSignal.getBaseTypes = function () {
        return ['AugLoop_Signals_Signal'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandResultsInternalSignal type or its inheritor and implements {@link IVoiceCommandResultsInternalSignal}
     */
    VoiceCommandResultsInternalSignal.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandResultsInternalSignal.getTypeName()]);
    };
    VoiceCommandResultsInternalSignal.H_ = { T_: VoiceCommandResultsInternalSignal.getTypeName(), B_: VoiceCommandResultsInternalSignal.getBaseTypes() };
    return VoiceCommandResultsInternalSignal;
}());
exports.VoiceCommandResultsInternalSignal = VoiceCommandResultsInternalSignal;
var VoiceCommandSuggestionInternalSignal = /** @class */ (function () {
    function VoiceCommandSuggestionInternalSignal(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandSuggestionInternalSignal, this, obj);
    }
    VoiceCommandSuggestionInternalSignal.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandSuggestionInternalSignal';
    };
    VoiceCommandSuggestionInternalSignal.getBaseTypes = function () {
        return ['AugLoop_Signals_Signal'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandSuggestionInternalSignal type or its inheritor and implements {@link IVoiceCommandSuggestionInternalSignal}
     */
    VoiceCommandSuggestionInternalSignal.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandSuggestionInternalSignal.getTypeName()]);
    };
    VoiceCommandSuggestionInternalSignal.H_ = { T_: VoiceCommandSuggestionInternalSignal.getTypeName(), B_: VoiceCommandSuggestionInternalSignal.getBaseTypes() };
    return VoiceCommandSuggestionInternalSignal;
}());
exports.VoiceCommandSuggestionInternalSignal = VoiceCommandSuggestionInternalSignal;
var BaseVoiceCommandSuggestion = /** @class */ (function () {
    function BaseVoiceCommandSuggestion(obj) {
        types_core_1.SchemaObject.assign(BaseVoiceCommandSuggestion, this, obj);
    }
    Object.defineProperty(BaseVoiceCommandSuggestion.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    BaseVoiceCommandSuggestion.getTypeName = function () {
        return 'AugLoop_Voice_BaseVoiceCommandSuggestion';
    };
    BaseVoiceCommandSuggestion.getBaseTypes = function () {
        return ['AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of BaseVoiceCommandSuggestion type or its inheritor and implements {@link IBaseVoiceCommandSuggestion}
     */
    BaseVoiceCommandSuggestion.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [BaseVoiceCommandSuggestion.getTypeName()]);
    };
    BaseVoiceCommandSuggestion.H_ = { T_: BaseVoiceCommandSuggestion.getTypeName(), B_: BaseVoiceCommandSuggestion.getBaseTypes() };
    return BaseVoiceCommandSuggestion;
}());
exports.BaseVoiceCommandSuggestion = BaseVoiceCommandSuggestion;
var VoiceCommandSuggestion = /** @class */ (function () {
    function VoiceCommandSuggestion(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandSuggestion, this, obj);
    }
    Object.defineProperty(VoiceCommandSuggestion.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    VoiceCommandSuggestion.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandSuggestion';
    };
    VoiceCommandSuggestion.getBaseTypes = function () {
        return ['AugLoop_Voice_BaseVoiceCommandSuggestion', 'AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandSuggestion type or its inheritor and implements {@link IVoiceCommandSuggestion}
     */
    VoiceCommandSuggestion.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandSuggestion.getTypeName()]);
    };
    VoiceCommandSuggestion.H_ = { T_: VoiceCommandSuggestion.getTypeName(), B_: VoiceCommandSuggestion.getBaseTypes() };
    return VoiceCommandSuggestion;
}());
exports.VoiceCommandSuggestion = VoiceCommandSuggestion;
var VoiceCommandSuggestionResult = /** @class */ (function () {
    function VoiceCommandSuggestionResult(obj) {
        types_core_1.SchemaObject.assign(VoiceCommandSuggestionResult, this, obj);
    }
    Object.defineProperty(VoiceCommandSuggestionResult.prototype, "metadata", {
        get: function () { return this.M_; },
        set: function (value) { this.M_ = value; },
        enumerable: false,
        configurable: true
    });
    VoiceCommandSuggestionResult.getTypeName = function () {
        return 'AugLoop_Voice_VoiceCommandSuggestionResult';
    };
    VoiceCommandSuggestionResult.getBaseTypes = function () {
        return ['AugLoop_Core_Annotation'];
    };
    /**
     * Checks if passed schema object is of VoiceCommandSuggestionResult type or its inheritor and implements {@link IVoiceCommandSuggestionResult}
     */
    VoiceCommandSuggestionResult.typeGuard = function (schemaObject) {
        return types_core_1.SchemaObject.matchesTypesFor(schemaObject, [VoiceCommandSuggestionResult.getTypeName()]);
    };
    VoiceCommandSuggestionResult.H_ = { T_: VoiceCommandSuggestionResult.getTypeName(), B_: VoiceCommandSuggestionResult.getBaseTypes() };
    return VoiceCommandSuggestionResult;
}());
exports.VoiceCommandSuggestionResult = VoiceCommandSuggestionResult;
//# sourceMappingURL=annotations-v2.g.js.map